import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Eye, Monitor, Search } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Skeleton } from '../../components/ui/skeleton';
import { StatusBadge } from '../../components/common/Badges';
import api from '../../lib/api';
import { fmtMoney, fmtDate } from '../../lib/format';

export default function MobileCotizacionesPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const { data: cotizaciones, isLoading } = useQuery({
    queryKey: ['quotations', 'mobile', '', search],
    queryFn: async () => {
      const params = {};
      if (search) params.search = search;
      return (await api.get('/quotations', { params })).data;
    },
  });

  return (
    <div className="space-y-4" data-testid="mobile-cotizaciones-page">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h2 className="text-xl font-semibold">Cotizaciones</h2>
          <p className="text-[12px] text-muted-foreground flex items-center gap-1"><Eye size={12} /> Vista móvil de solo lectura</p>
        </div>
        <Button variant="outline" size="sm" className="h-8 text-[12px]" onClick={() => navigate('/cotizaciones')} data-testid="mobile-desktop-link">
          <Monitor size={13} className="mr-1.5" /> Escritorio
        </Button>
      </div>

      <div className="relative">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar cotización..." className="pl-9" data-testid="mobile-search-input" />
      </div>

      {isLoading ? (
        <div className="space-y-3">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-20" />)}</div>
      ) : (cotizaciones || []).length === 0 ? (
        <Card className="border-border"><CardContent className="py-12 text-center text-muted-foreground text-sm">Sin cotizaciones</CardContent></Card>
      ) : (
        <div className="space-y-2.5">
          {(cotizaciones || []).map((q) => (
            <Card
              key={q.id}
              className="border-border shadow-[var(--shadow-elev-1)] cursor-pointer active:bg-card/70"
              onClick={() => navigate(`/m/cotizaciones/${q.id}`)}
              data-testid={`mobile-quotation-card-${q.quotation_number}`}
            >
              <CardContent className="py-3.5 px-4">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-mono text-[12px] text-muted-foreground">{q.quotation_number}</span>
                  <StatusBadge status={q.status} />
                </div>
                <div className="font-medium text-[14px] truncate mt-0.5">{q.nombre}</div>
                <div className="flex items-center justify-between mt-1.5">
                  <span className="text-[12px] text-muted-foreground">{q.cliente_nombre || '—'} · {fmtDate(q.updated_at)}</span>
                  <span className="money text-[14px] font-semibold text-primary">{fmtMoney(q.totals?.total, q.moneda)}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
